<template>
    <div id='admin_note_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Admin Note</p>
                <button class="delete" aria-label="close" @click="doClose('admin_note_modal')"></button>
            </header>
            <section class="modal-card-body">
                <textarea id=adminnote_text class='textarea' rows=5></textarea>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="doSave()">
                    Save
                </button>
                <button class="button" @click="doClose('admin_note_modal')">
                    Cancel
                </button>
            </footer>
        </div>
    </div>
</template>


<script>
export default {
    name: "UserNoteModal",
    methods: {
        doClose(option) {
            this.$emit('doClose', option)
        },
        doSave() {
            this.$emit('doSave')
        }
    }
};
</script>